export class HandoverV2DetailStt {
  bagCustomChargeableWeight = 0;
  bagCustomGrossWeight = 0;
  bagCustomVolumeWeight = 0;
  bagTotalChargeableWeight = 0;
  bookingId = "";
  deadlineReturn = "";
  flag = "";
  isCod = false;
  isDangerousGoods = false;
  isDfod = false;
  isDg = false;
  isDisputeBagging = false;
  isFlaggedForPriorityRts = false;
  isMissroute = false;
  isQuarantine = false;
  isScanByBag = false;
  isStiDest = 0;
  isTransit = false;
  message = "";
  packageNumber = null;
  piece = [];
  refNo = "";
  statusReturn = "";
  stiDestOneBagScan = false;
  sttAssessmentStatus = "";
  sttChargeableWeight = 0;
  sttClientId = 0;
  sttCommodityCode = "";
  sttCommodityName = "";
  sttCommodityNameEn = "";
  sttDestinationCityId = "";
  sttDestinationCityName = "";
  sttDestinationDistrictUrsacode = "";
  sttDestinationRegionName = "";
  sttGrossWeight = 0;
  sttId = 0;
  sttLastStatusId = "";
  sttNeedToRelabel = false;
  sttNo = "";
  sttNoRefExternal = "";
  sttOriginCityId = "";
  sttOriginCityName = "";
  sttOriginRegionName = "";
  sttPaymentStatus = "";
  sttProductType = "";
  sttRecipientAddress = "";
  sttRecipientName = "";
  sttRecipientPhone = "";
  sttRegionId = "";
  sttRegionName = "";
  sttShipmentId = "";
  sttTotalPiece = 0;
  sttVolumeWeight = 0;
  sttWoodPacking = "";

  constructor(fields?: Partial<HandoverV2DetailStt>) {
    Object.assign(this, fields);
  }
}

export class HandoverV2Detail {
  bagStt = [] as HandoverV2DetailStt[];
  eligibleVendors: HandoverV2Detail[] = [];
  errorMessage = "";
  handoverType = "";
  isAllowUpdateStatus = 0;
  isPaid = false;
  isSuccess = false;
  isVendorChangeable = false;
  isVendorInternal = false;
  manifestKey = "";
  stt = new HandoverV2DetailStt();
  vendorCode = "";
  vendorName = "";
  destinationPartnerType = "";
  destinationPartnerId = 0;
  destinationPartnerCode = "";
  apiIntegration = false;
  remarks = "";
  error = "";
  isAvailable = true;
  reason = "";
  reasonEn = "";
  constructor(fields?: Partial<HandoverV2Detail>) {
    Object.assign(this, fields);

    if (fields?.stt) {
      this.stt = new HandoverV2DetailStt(fields.stt);
    }

    if (fields?.bagStt) {
      this.bagStt = fields.bagStt.map(
        (bagStt) => new HandoverV2DetailStt(bagStt)
      );
    }

    if (fields?.eligibleVendors) {
      this.eligibleVendors = fields.eligibleVendors.map(
        (vendor) => new HandoverV2Detail(vendor)
      );
    }
  }
}

export class DraftScanPagination {
  currentPage = 1;
  pageSize = 10;
  totalItems = 0;
  constructor(fields?: Partial<DraftScanPagination>) {
    Object.assign(this, fields);
  }
}

export class DraftScanList {
  items: HandoverV2Detail[] = [];
  pagination = new DraftScanPagination();
  constructor(fields?: Partial<DraftScanList>) {
    Object.assign(this, fields);
  }
}

// Failed scans panel from GET /draft/scans/failed
export class DraftFailedScan {
  barcode = "";
  sttNo = "";
  reason = "";
  failedAt = "";
  constructor(fields?: Partial<DraftFailedScan>) {
    Object.assign(this, fields);
  }
}

export class DraftFailedScanList {
  items: DraftFailedScan[] = [];
  pagination = new DraftScanPagination();
  constructor(fields?: Partial<DraftFailedScanList>) {
    Object.assign(this, fields);
  }
}

// Page scope
export class ScanPageScope {
  isLoading = false;
  isError = false;
  errorMessage: string | null = null;

  constructor(fields?: Partial<ScanPageScope>) {
    Object.assign(this, fields);
  }
}

// Results table row
export class ScanResultRow {
  rowNo = 0;
  sttNo = "";
  badges: string[] = [];
  courierName = "";
  courierId = "";
  courierPhone = "";
  dexDate = "";
  dexReason = "";
  reconciledAt: string | null = null;
  isDebtReconcile = false;
  debtDays: number | null = null;
  scannedAt = "";

  constructor(fields?: Partial<ScanResultRow>) {
    Object.assign(this, fields);
  }
}

// Scan panel scope
export class ScanFailedScanItem {
  barcode = "";
  reason = "";
  failedAt: string | null = null;

  constructor(fields?: Partial<ScanFailedScanItem>) {
    Object.assign(this, fields);
  }
}

export class ScanPanelState {
  barcodeInputValue = "";
  isScanning = false;
  isInputDisabled = false;
  lastScanRow: ScanResultRow | null = null;
  failedScans: ScanFailedScanItem[] = [];

  constructor(fields?: Partial<ScanPanelState>) {
    Object.assign(this, fields);
  }
}

// Results panel scope
export class ResultsPanelFilter {
  keyword = "";
  product = "";
  commodity = "";

  constructor(fields?: Partial<ResultsPanelFilter>) {
    Object.assign(this, fields);
  }
}

export class ResultsPanelState {
  filters = new ResultsPanelFilter();
  rows: ScanResultRow[] = [];
  isEmpty = true;

  constructor(fields?: Partial<ResultsPanelState>) {
    Object.assign(this, fields);
  }
}

// Page aggregate
export class ScanPageState {
  page = new ScanPageScope();
  scanPanel = new ScanPanelState();
  resultsPanel = new ResultsPanelState();

  constructor(fields?: Partial<ScanPageState>) {
    Object.assign(this, fields);
  }
}
